module.exports = __webpack_public_path__ + "img/rainy.bf0f703e.svg";